<template>
  <div class="ApprovalManagement">
    <AppHeader>审批管理</AppHeader>
    <AppBox class="appBox" id="appBox">
      <div class="tableFilter">
        <el-form :inline="true" :model="filter" size="small" ref="form">
          <el-form-item label="所属系列">
            <el-select
                style="width: 150px"
                v-model="filter.classSubjectId"
                v-scroll="loadMore"
                placeholder="请选择"
                @change="onSubmit"
            >
              <el-option
                  v-for="item in classNameList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态">
            <el-select
                style="width: 150px"
                v-model="filter.states"
                placeholder="请选择"
                @change="onSubmit"
            >
              <el-option
                  v-for="item in approvalStateOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上传时间">
            <el-date-picker
                style="width: 250px"
                v-model="filter.dateRange"
                value-format="timestamp"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="onSubmit"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-input
                v-model="filter.keyword"
                placeholder="老师姓名|系列名称"
                @keyup.enter.native="onSubmit"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">查找</el-button>
            <el-button @click="onReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <ApprovalList :maxHeight="maxHeight"></ApprovalList>
    </AppBox>
  </div>
</template>

<script>
import AppBox from "@/components/ui/AppBox/index.vue";
import AppHeader from "@/components/ui/AppHeader/index.vue";
import {mapActions, mapMutations, mapState} from "vuex";
import {APPROVAL_STATES} from "@/utils/constants";
import ApprovalList from "@/pages/ApprovalManagement/ApprovalList.vue";

export default {
  name: "ApprovalManagement",
  components: {ApprovalList, AppHeader, AppBox},
  data() {
    const approvalStateOptions = Object.keys(APPROVAL_STATES).map((key) => {
      return {
        value: Number(key),
        label: APPROVAL_STATES[key],
      };
    });
    return {
      maxHeight: null,
      approvalStateOptions: [
        {
          value: null,
          label: "全部",
        },
        ...approvalStateOptions,
      ],
      classNameList: [
        {
          id: null,
          name: "全部",
        },
      ],
    };
  },
  computed: {
    ...mapState("teachingCenter", ["seriesList"]),
    filter: {
      get() {
        return this.$store.state.teachingCenter.lessonVerifyResponseListFilter;
      },
      set(value) {
        this.$store.commit("teachingCenter/setData", {
          key: "lessonVerifyResponseListFilter",
          value,
        });
      },
    },
  },
  async mounted() {
    await this.getSeriesList({});
    this.classNameList = this.classNameList.concat(this.seriesList.data);
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize); // 移除resize事件监听
  },
  methods: {
    ...mapActions("teachingCenter", [
      "getLessonVerifyResponseList",
      "getSeriesList",
    ]),
    ...mapMutations("teachingCenter", ["clearFilter"]),
    handleResize() {
      this.$nextTick(() => {
        const el = document.getElementById("appBox");
        if (el.offsetHeight <= 650) {
          this.maxHeight = el.offsetHeight - el.offsetHeight * 0.56;
        } else {
          this.maxHeight = el.offsetHeight - el.offsetHeight * 0.3;
        }
      });
    },
    async loadMore() {
      const currentPage = this.seriesList.page;
      const currentSize = this.seriesList.size;
      const currentTotal = this.seriesList.total;
      if (currentPage * currentSize < currentTotal) {
        await this.getSeriesList({
          page: this.seriesList.page + 1,
        });
        this.classNameList = this.classNameList.concat(this.seriesList.data);
      }
    },
    async onSubmit() {
      const filters = {
        ...this.filter,
        startTime: this.filter.dateRange ? this.filter.dateRange[0] : null,
        endTime: this.filter.dateRange ? this.filter.dateRange[1] : null,
      };
      filters.dateRange = undefined;
      await this.$refs.form.validate(async (valid) => {
        if (valid) {
          await this.getLessonVerifyResponseList({
            ...filters,
            page: 1,
          });
        }
      });
    },
    // 重置
    async onReset() {
      await this.clearFilter();
      await this.getLessonVerifyResponseList({
        page: 1,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.ApprovalManagement {
  .appBox {
    height: calc(100vh - 155px);
    min-height: 330px;

    .tableFilter {
      padding-bottom: 20px;

      .el-form-item {
        margin-right: 30px;
      }

      ::v-deep .el-range-separator {
        width: 20px !important;
      }
    }
  }
}
</style>
